export const employeeTypeOption = [
  { label: 'Permanente', value: 'PE', id: 'PE' },
  { label: 'Temporal', value: 'FI', id: 'FI' },
]

export const genderOptions = [
  { label: 'Masculino', value: 'M', id: 'M' },
  { label: 'Femenino', value: 'F', id: 'F' },
]

export const contactTypes = [
  { label: 'AmiGo', value: 'AMIGO', id: 'AMIGO' },
  { label: 'Contable', value: 'CONTABLE', id: 'CONTABLE' },
  { label: 'Decidor', value: 'DECIDOR', id: 'DECIDOR' },
  { label: 'Empresa', value: 'EMPRESA', id: 'EMPRESA' },
  { label: 'Operacional', value: 'OPERACIONAL', id: 'OPERACIONAL' },
  { label: 'Otro', value: 'OTRO', id: 'OTRO' },
  {
    label: 'Salacuna Solicitudes',
    value: 'SALACUNA_SOLICITUDES',
    id: 'SALACUNA_SOLICITUDES',
  },
]
